import React, { FC } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'

import { TYPE_NAMES } from '../../../constants'
import { IOfficialRepresentativeProps } from '../../../types'

import { AvatarWrapper, AvatarMaskStyled, AvatarStyled, Container } from '../styles'

const OfficialRepresentative: FC<IOfficialRepresentativeProps> = ({
  type,
  fullName,
  avatar,
  handleOpenDialog,
  size = 'medium',
}) => {
  return (
    <>
      <Container>
        <Text textAlign='center' lineHeight='h4' fontSize='h5'>
          {`Представитель ${TYPE_NAMES[type]}`}
        </Text>

        <Spacing spacing='small' />

        <AvatarWrapper>
          <AvatarMaskStyled />
          <AvatarStyled imgUrl={avatar?.thumb?.fallbackUrl} size='uxlarge' />
        </AvatarWrapper>

        <Spacing spacing='small' />

        <Text textAlign='center' fontWeight='bold' lineHeight='h4' fontSize='h4'>
          {fullName}
        </Text>

        <Spacing spacing='small' />

        <Button block color='blue' onClick={handleOpenDialog} size={size}>
          Задать вопрос
        </Button>
      </Container>
    </>
  )
}

export default OfficialRepresentative
